import React from 'react';

class AssetStatusFormatter extends React.Component {
	render() {
    const { renderedCellValue } = this.props;
		let dot;
		let text;
		switch (parseInt(renderedCellValue)) {
			case 0:
				dot = 'Fielder-grey-dot';
				text = 'Inactive';
				break;
			case 1:
				dot = 'Fielder-pink-dot';
				text = 'Active';
				break;
		}
		return (
			<div className='row'>
				<div className='col-1'>
					<div className={`SmartTable-circle-texture text-center ${dot}`} />
				</div>
				<div className='my-auto col-7 pl-1'>{text}</div>
			</div>
		);
	}
}

export default AssetStatusFormatter;
